// Format a timestamp in mm/dd/yyyy hh:mm:ss AM/PM format
export const formatTimestamp = (timestamp?: string): string | undefined => {
  if (!timestamp) return undefined;

  try {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return undefined;

    return date
      .toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
      .replace(",", "");
  } catch {
    return undefined;
  }
};

// Format camelCase text by adding spaces before capital letters
// Example: "BumpableBuyer" -> "Bumpable Buyer"
export const formatCamelCase = (text: string): string => {
  if (!text || typeof text !== "string") return text || "";
  return text.replace(/([A-Z])/g, " $1").trim();
};

// Format text with placeholders
export const formatPlaceholders = (
  text: string,
  context: Record<string, string>
): string => {
  let formattedText = text;

  // Get current date/time
  const now = new Date();

  // Format current date/time in various formats
  const dateContext = {
    "{yyyy}": now.getFullYear().toString(),
    "{mm/dd/yyyy}": now.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    }),
    "{mm/dd/yyyy hh:mm:ss AM/PM}": formatTimestamp(now.toISOString()) || "",
  };

  // Combine date context with provided context
  const allContext = { ...dateContext, ...context };

  // Replace all placeholders
  Object.entries(allContext).forEach(([placeholder, value]) => {
    formattedText = formattedText.replace(new RegExp(placeholder, "g"), value);
  });

  return formattedText;
};
